module.exports = __webpack_public_path__ + "static/media/three_pote_pricing.81c68e50.png";